export const getImageproxyUrl = (url, height) => {
  const config = window.getConfig();

  if (!config.useImageproxy || !url) {
    return url;
  }

  const protocolEnd = url.indexOf('://');
  if (protocolEnd === -1) {
    return url;
  }

  const pathStart = url.indexOf('/', protocolEnd + 3);
  if (pathStart === -1) {
    return url;
  }

  const width = Math.round(height * 16 / 9);

  return `${url.substr(0, pathStart)}/jpg,${width}x${height},fit${url.substr(pathStart)}`;
};
